export default "__VITE_ASSET__Bgt4bWBY__"